import { App, routes as allRoutes } from "@songtradr-sso/shared/common";
import { staticText } from "../../shared/statics/static-text";

// TEXT
export const text = staticText.emailSignUp;

// STYLES

// DATA

// TYPES

// CONSTANTS
export const routes = allRoutes[App.Core];

// FUNCTIONS

// ASSETS
